import { render, staticRenderFns } from "./HealthrecordsDetail.vue?vue&type=template&id=cf5f4a0a&"
import script from "./HealthrecordsDetail.vue?vue&type=script&lang=js&"
export * from "./HealthrecordsDetail.vue?vue&type=script&lang=js&"
import style0 from "./HealthrecordsDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports